import React, { useState, useEffect } from "react";
import debounce from 'lodash/debounce';

function FormMetricRange({ rangeDetails, formDataHandle, setRangeDetails }) {
  const [rangeDetailState, setRangeDetailState] = useState(null);

  useEffect(() => {
    setRangeDetailState(rangeDetails)

    setTimeout(() => {
      rangeDetails.map((ele) => {
        jQuery(`#${ele.rangeId}`).ionRangeSlider({
          type: "double",
          grid: true,
          min: minMaxDataGlobal[ele['saveValue']].min,
          max: minMaxDataGlobal[ele['saveValue']].max,
          from: ele.setMin,
          to: ele.setMax,
          skin: "round",
          name: ele.saveValue,
          inputFromId: ele.inputFromId,
          inputToId: ele.inputToId,
          checkBoxValue: ele.checkBoxValue,
          onFinish: update,
        });
      });
    }, 15);
  }, [rangeDetails]);

  function update(data) {
    var $inp = $(this);
    let name = $inp[0].name;
    updateInputs(data, name);
  }

  const updateInputs = debounce((data, name) => {
    formDataHandle("range", data, name);
  }, 600);

  const inputChangeHandler = debounce((event) => {
    let rangeConfig = []
    rangeDetailState.map((ele) => {
      if (ele.saveValue == event.name && ele.checkBoxValue === true) {
        let instance = $(`#${ele.rangeId}`).data("ionRangeSlider");
        if (event.id == ele.inputFromId) {
          instance.update({
            from: event.value,
          });
          rangeConfig.push({
            metricLabel: ele.metricLabel,
            metricValue: ele.metricValue,
            rangeId: ele.rangeId,
            inputFromId: ele.inputFromId,
            inputToId: ele.inputToId,
            saveValue: ele.saveValue,
            setMin: event.value,
            setMax: instance.old_to,
            checkBoxValue: ele.checkBoxValue,
          });
        } else {
          instance.update({
            to: event.value,
          });
          rangeConfig.push({
            metricLabel: ele.metricLabel,
            metricValue: ele.metricValue,
            rangeId: ele.rangeId,
            inputFromId: ele.inputFromId,
            inputToId: ele.inputToId,
            saveValue: ele.saveValue,
            setMin: instance.old_from,
            setMax: event.value,
            checkBoxValue: ele.checkBoxValue,
          });
        }
      } else {
        rangeConfig.push(ele);
      }
    });
    setRangeDetailState(rangeConfig);
    setRangeDetails(rangeConfig);
  }, 1000)

  const checkBoxStateFunction = (event) => {
    let tempArray = [...rangeDetails];
    tempArray.map(singleElement => {
      if (singleElement.metricLabel === event.target.name) {
        singleElement['checkBoxValue'] = !singleElement['checkBoxValue'];
      }
    })
    setRangeDetails(tempArray);
  }

  return (
    <>
      {rangeDetailState
        ? rangeDetailState.map((ele, index) => {
          return (
            <div className="d-inline-block mg-b-10 mg-r-5 custom-control custom-checkbox" key={`${ele.metricValue}_${index}`}>
              <input
                name={ele.metricLabel}
                type="checkbox"
                className="custom-control-input"
                id={`${ele.metricLabel}_checkbox_${index}`}
                checked={ele.checkBoxValue}
                onChange={checkBoxStateFunction}
              />
              <label className="custom-control-label" htmlFor={`${ele.metricLabel}_checkbox_${index}`}>{`${ele.metricLabel} Slider`}</label>
            </div>
          )
        })
        : null}
      {rangeDetailState
        ? rangeDetailState.map((ele, index) => {
          if (ele.checkBoxValue === true) {
            return (
              <div className="card" key={index}>
                <div className="card-body form-group">
                  <label for="formGroupExampleInput" className="card-title d-block">
                    {`${ele.metricLabel} Slider`}
                  </label>
                  <input
                    type="text"
                    id={ele.rangeId}
                    className="js-range-slider form-control custom-control-input"
                    name="my_range"
                    defaultValue=""
                  />
                </div>
                <div className="card-footer form-group extra-controls" key={index}>
                  <input
                    key={`${index}_input_from`}
                    type="text"
                    id={ele.inputFromId}
                    className="js-input-from"
                    name={ele.saveValue}
                    onChange={(e) => inputChangeHandler(e.target)}
                    defaultValue={ele.setMin}
                  />
                  <input
                    key={`${index}_input_to`}
                    type="text"
                    id={ele.inputToId}
                    className="js-input-to"
                    name={ele.saveValue}
                    onChange={(e) => inputChangeHandler(e.target)}
                    defaultValue={ele.setMax}
                  />
                </div>
              </div>
            );
          }
        })
        : null}
    </>
  );
}

export default FormMetricRange;